var m = require('mithril');
var prop = require('mithril/stream');
var _ = require('lodash');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var equipmentTree = require('./equipmentTree');


var hasEquipmentModal = Object.assign(Object.create(Model), require('../../../../../models/system/hasEquipment'));

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


hasEquipmentModal.editDialogue = function (record, options) {
  Model.initForm.call(hasEquipmentModal, record);
  
  if ( 
    record && 
    record.parentSystem && 
    record.parentSystem.out_hasEquipment && 
    Array.isArray(record.parentSystem.out_hasEquipment) &&
    record.parentSystem.out_hasEquipment.length > 0
  ) {
    hasEquipmentModal.recordsToExclude = record.parentSystem.out_hasEquipment.map((edge) => edge.in['@rid']);
  }
  var submit = function () {
    hasEquipmentModal.form.parentSystem() && hasEquipmentModal.form.parentSystem()['@rid'] ? hasEquipmentModal.form.parentSystem(hasEquipmentModal.form.parentSystem()['@rid']) : '';
    hasEquipmentModal.form.childEquipment() && hasEquipmentModal.form.childEquipment()['@rid'] ? hasEquipmentModal.form.childEquipment(hasEquipmentModal.form.childEquipment()['@rid']) : '';
    hasEquipmentModal.save()
    .then(function (result) {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
  };

  key.setScope('modal');
  key('enter', 'modal', submit);
  modal.vm.title('Add Equipment to System: ')
  modal.vm.body = hasEquipmentModal.view,
  modal.vm.buttons([
    {
      label: "Save",
      class: record ? "dib mr2 ": "btn-good",
      func: submit
    }
  ]);
  hasEquipmentModal.findedCategory = prop();
  modal.vm.open();
}


hasEquipmentModal.view = function () {
  return m('form', {role:'form'}, [
    hasEquipmentModal.errorView(),
    m(equipmentTree, {
      selectedNode: hasEquipmentModal.form.childEquipment, 
      recordsToExclude: hasEquipmentModal.recordsToExclude
    }),
  ])
}


module.exports = hasEquipmentModal;